import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'
import { Box, Modal, Tooltip, Typography } from '@mui/material'
import { ScreenEnum, useScreen } from 'feature/screenMode'
import { FC, useState } from 'react'

import styles from './OrderNeedPay.module.scss'

export const OrderNeedPay: FC = () => {
  const [open, setOpen] = useState(false)
  const handleOpen = (e: { preventDefault: () => void }) => {
    e.preventDefault()
    setOpen(true)
  }
  const handleClose = () => setOpen(false)
  const screen = useScreen()

  if (screen !== ScreenEnum.desktop)
    return (
      <>
        <button onClick={handleOpen} className={styles.infoText}>
          <ErrorOutlineIcon />
          <span>Возможен платный выезд, уточняйте у специалиста</span>
        </button>
        <Modal open={open} onClose={handleClose}>
          <>
            <Box className={styles.modal}>
              <Typography>
                После оформления заявки с Вами свяжется дилер для уточнения
                нюансов по заказу.
              </Typography>
            </Box>
          </>
        </Modal>
      </>
    )

  return (
    <>
      <Tooltip
        title={`После оформления заявки с Вами свяжется дилер для уточнения нюансов по заказу.`}
        placement='bottom'
      >
        <Box className={styles.infoText}>
          <ErrorOutlineIcon />
          <span>Возможен платный выезд, уточняйте у специалиста</span>
        </Box>
      </Tooltip>
    </>
  )
}
